<div class="stock-container">
  <div class="stock-topbar">
    <div class="topbar-left">
      <h1>
        Current Stock
        <small>Real-time inventory balance</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i> IMS / <span>Inventory</span> / <span class="current">Current Stock</span>
        <span class="separator">|</span>
        <span class="time"><i class="bi bi-clock"></i> {{ timestamp() }}</span>
      </div>
    </div>
    <div class="topbar-right">
      <div class="search-box">
        <i class="bi bi-search"></i>
        <input
          type="text"
          placeholder="Search stock items..."
          [ngModel]="search()"
          (ngModelChange)="search.set($event); onSearchChange()"
        />
      </div>
      <button class="btn btn-outline btn-sm" type="button" (click)="exportData()">
        <i class="bi bi-download"></i> Export
      </button>
      <button class="btn btn-outline btn-sm" type="button" (click)="printPage()">
        <i class="bi bi-printer"></i> Print
      </button>
    </div>
  </div>

  <div class="stats-row">
    <div class="stat-card">
      <div class="stat-icon blue">
        <i class="bi bi-box-seam"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Total Items</div>
        <div class="stat-value">{{ stats().totalItems }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon green">
        <i class="bi bi-check-circle"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Available</div>
        <div class="stat-value">{{ stats().available }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon amber">
        <i class="bi bi-clock"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Reserved</div>
        <div class="stat-value">{{ stats().reserved }}</div>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon red">
        <i class="bi bi-exclamation-triangle"></i>
      </div>
      <div class="stat-info">
        <div class="stat-label">Low / Out of Stock</div>
        <div class="stat-value">{{ stats().lowOrOut }}</div>
      </div>
    </div>
  </div>

  <div class="filter-bar">
    <div class="filter-left">
      <div class="filter-group">
        <label><i class="bi bi-building"></i> Branch</label>
        <select [ngModel]="branchFilter()" (ngModelChange)="branchFilter.set($event); onFilterChange()">
          @if (!branchFilterLocked()) {
            <option value="all">All Branches</option>
          }
          @for (branch of branches(); track branch.id) {
            <option [value]="branch.name">{{ branch.name }}</option>
          }
        </select>
      </div>
      <div class="filter-group">
        <label><i class="bi bi-geo-alt"></i> Location</label>
        <select [ngModel]="locationFilter()" (ngModelChange)="locationFilter.set($event); onFilterChange()">
          <option value="all">All Locations</option>
          @for (loc of locations(); track loc.id) {
            <option [value]="loc.name">{{ loc.name }}</option>
          }
        </select>
      </div>
      <div class="filter-group">
        <label><i class="bi bi-tags"></i> Category</label>
        <select [ngModel]="categoryFilter()" (ngModelChange)="categoryFilter.set($event); onFilterChange()">
          <option value="all">All Categories</option>
          @for (cat of categories(); track cat.id) {
            <option [value]="cat.name">{{ cat.name }}</option>
          }
        </select>
      </div>
    </div>
    <div class="filter-right">
      <span class="filter-count">Showing {{ filteredSnapshots().length }} items</span>
      <button class="btn btn-outline btn-sm" type="button" (click)="clearFilters()">Clear filters</button>
    </div>
  </div>

  <div class="stock-grid">
    @for (snapshot of paginatedSnapshots(); track snapshot.id) {
      <div class="stock-card" [class]="stockCardClass(snapshot)" (click)="openStockModal(snapshot)">
        <div class="stock-status" [class]="stockCardClass(snapshot)">
          <span class="dot"></span>
          <span>{{ stockStatusLabel(snapshot) }}</span>
        </div>
        <div class="stock-icon"><i class="bi bi-box-seam"></i></div>
        <div class="stock-info">
          <div class="stock-name">{{ snapshot.itemName }}</div>
          <div class="stock-category">{{ snapshot.category }}</div>
        </div>
        <div class="stock-balance">
          <div class="balance-item">
            <span class="balance-label">On Hand</span>
            <span class="balance-value">{{ snapshot.quantity }}</span>
          </div>
          <div class="balance-item">
            <span class="balance-label">Reserved</span>
            <span class="balance-value">{{ getReservedQuantity(snapshot) }}</span>
          </div>
          <div class="balance-item">
            <span class="balance-label">Available</span>
            <span class="balance-value">{{ getAvailableQuantity(snapshot) }}</span>
          </div>
        </div>
        <div class="stock-location">
          <div class="location-item">
            <i class="bi bi-building"></i>
            <span>{{ snapshot.branch || 'N/A' }}</span>
          </div>
          <div class="location-item">
            <i class="bi bi-geo-alt"></i>
            <span>{{ snapshot.location || 'N/A' }}</span>
          </div>
        </div>
        <div class="stock-click-hint">
          <span><i class="bi bi-pencil"></i> Click to adjust</span>
          @if (canTrack(snapshot)) {
            <button type="button" class="btn-track" (click)="openItemHistory(snapshot, $event)">
              <i class="bi bi-geo-alt"></i> Track
            </button>
          }
        </div>
      </div>
    } @empty {
      <div class="empty-state">
        <i class="bi bi-inbox"></i>
        <p>No stock items match your search or filters.</p>
      </div>
    }
  </div>

  <div class="pagination-bar">
    <div class="pagination-info">
      Showing <span>{{ paginationStart() }}</span> to <span>{{ paginationEnd() }}</span> of <span>{{ filteredSnapshots().length }}</span> items
    </div>
    <div class="pagination-controls">
      <button class="btn btn-outline btn-sm" [disabled]="page() === 1" (click)="goToPage(page() - 1)"><i class="bi bi-chevron-left"></i> Previous</button>
      @for (p of pageNumbers(); track p) {
        <button class="btn btn-sm" [class.btn-primary]="page() === p" [class.btn-outline]="page() !== p" (click)="goToPage(p)">{{ p }}</button>
      }
      <button class="btn btn-outline btn-sm" [disabled]="page() === totalPages()" (click)="goToPage(page() + 1)">Next <i class="bi bi-chevron-right"></i></button>
    </div>
  </div>
</div>

<!-- Stock Adjustment Modal -->
<div class="modal-overlay" [class.open]="showStockModal()" (click)="closeModalOnBackdrop($event)">
  <div class="modal modal-medium">
    <div class="modal-header">
      <h2>
        <i class="bi bi-box-seam"></i>
        Adjust Stock
      </h2>
      <button class="close-btn" (click)="closeStockModal()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-body">
      @if (selectedStock()) {
        <div class="stock-details">
          <div class="detail-row">
            <span class="detail-label">Item Name</span>
            <span class="detail-value">{{ selectedStock()?.itemName }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Item Code</span>
            <span class="detail-value">{{ selectedStock()?.itemCode }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Category</span>
            <span class="detail-value">{{ selectedStock()?.category }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Branch</span>
            <span class="detail-value">{{ selectedStock()?.branch || 'N/A' }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Location</span>
            <span class="detail-value">{{ selectedStock()?.location || 'N/A' }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">Current Stock</span>
            <span class="detail-value highlight">{{ selectedStock()?.quantity }}</span>
          </div>
        </div>

        <div class="adjustment-form">
          <div class="form-row">
            <div class="form-group">
              <label>Adjustment Type <span class="required">*</span></label>
              <select [ngModel]="adjustmentType()" (ngModelChange)="adjustmentType.set($event)">
                <option value="add">Add Stock</option>
                <option value="remove">Remove Stock</option>
                <option value="set">Set Stock</option>
              </select>
            </div>
            <div class="form-group">
              <label>Quantity <span class="required">*</span></label>
              <input
                type="number"
                [min]="adjustmentType() === 'set' ? 0 : 1"
                step="1"
                [ngModel]="adjustmentQuantity()"
                (ngModelChange)="onAdjustmentQuantityChange($event)"
              />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>Reason <span class="required">*</span></label>
              <select [ngModel]="adjustmentReason()" (ngModelChange)="adjustmentReason.set($event)">
                <option value="">Select Reason</option>
                <option value="purchase">Purchase Order</option>
                <option value="sale">Sales Order</option>
                <option value="return">Customer Return</option>
                <option value="damage">Damaged Goods</option>
                <option value="expired">Expired Stock</option>
                <option value="count">Stock Count</option>
                <option value="transfer">Stock Transfer</option>
                <option value="adjustment">Manual Adjustment</option>
              </select>
            </div>
            <div class="form-group">
              <label>Notes</label>
              <input type="text" placeholder="Optional notes" [ngModel]="adjustmentNotes()" (ngModelChange)="adjustmentNotes.set($event)" />
            </div>
          </div>
        </div>

        @if (adjustmentType() !== 'set') {
          <div class="adjustment-preview">
            <div class="preview-row">
              <span>Current Stock:</span>
              <span class="preview-value">{{ selectedStock()?.quantity }}</span>
            </div>
            <div class="preview-row">
              <span>Available:</span>
              <span class="preview-value">{{ getAvailableQuantity(selectedStock()!) }}</span>
            </div>
            <div class="preview-row" [class.positive]="adjustmentType() === 'add'" [class.negative]="adjustmentType() === 'remove'">
              <span>{{ adjustmentType() === 'add' ? '+' : '-' }}</span>
              <span class="preview-value">{{ adjustmentQuantity() }}</span>
            </div>
            <div class="preview-row total">
              <span>New Stock:</span>
              <span class="preview-value highlight">
                {{ calculateNewStock() }}
              </span>
            </div>
          </div>
        }

        @if (adjustmentType() === 'set') {
          <div class="adjustment-preview">
            <div class="preview-row total">
              <span>New Stock:</span>
              <span class="preview-value highlight">{{ adjustmentQuantity() }}</span>
            </div>
          </div>
        }
      }
    </div>

    <div class="modal-footer">
      <button class="btn btn-outline" (click)="closeStockModal()">Cancel</button>
      <button class="btn btn-primary" (click)="submitStockAdjustment()">
        <i class="bi bi-check-lg"></i> Confirm Adjustment
      </button>
    </div>
  </div>
</div>

<!-- Toast Notification -->
@if (showToast()) {
  <div class="toast-container show">
    <div class="toast" [class.success]="toastType() === 'success'" [class.error]="toastType() === 'error'" [class.info]="toastType() === 'info'">
      <div class="toast-icon" [class.success]="toastType() === 'success'" [class.error]="toastType() === 'error'" [class.info]="toastType() === 'info'">
        <i class="bi"
          [class.bi-check-circle-fill]="toastType() === 'success'"
          [class.bi-exclamation-circle-fill]="toastType() === 'error'"
          [class.bi-info-circle-fill]="toastType() === 'info'"></i>
      </div>
      <div class="toast-content">
        <div class="toast-title">
          {{ toastType() === 'success' ? 'Success!' : toastType() === 'error' ? 'Error!' : 'Notice' }}
        </div>
        <div class="toast-message">{{ toastMessage() }}</div>
      </div>
    </div>
  </div>
}
